import React, { useEffect, useMemo, useRef, useState } from "react";
import Popup from "devextreme-react/popup";
import DataSource from "devextreme/data/data_source";
import { criarPrefeituraDs } from "../../DataSources";
import UserInfo from "../../UserInfo";
import apiAxios from "../../api-axios";
import { getToken, login } from "../../auth";
import { escolhaObrigatoria, aplicarTroca, filtrarPrefeituras } from "./regras";
import "./seletor-prefeitura.scss";

function gravarSessao(dados) {
  UserInfo.setUsuario(dados);
  login(dados.tokenStr);
}

// Popup de troca de prefeitura (perfil trimap). Abre sozinho e sem botão de fechar
// enquanto o token estiver na prefeitura 0.
export default function SeletorPrefeitura({ aberto, onFechar }) {
  const obrigatoria = UserInfo.eSuporte() && escolhaObrigatoria(UserInfo.getPrefeitura());
  const visivel = obrigatoria || !!aberto;
  const prefeituraAtual = UserInfo.getPrefeitura();

  const [prefeituras, setPrefeituras] = useState([]);
  const [erro, setErro] = useState("");
  const [trocando, setTrocando] = useState(false);
  const [filtro, setFiltro] = useState("");
  const campoBusca = useRef(null);
  const visiveis = filtrarPrefeituras(prefeituras, filtro);

  // O filtro volta vazio sempre que a popup fecha.
  useEffect(() => {
    if (!visivel) {
      setFiltro("");
    }
  }, [visivel]);

  const dataSource = useMemo(
    () =>
      new DataSource({
        store: criarPrefeituraDs(),
        remoteOperations: false,
        sort: [{ selector: "prefeituraTopo", desc: false }],
      }),
    []
  );

  useEffect(() => {
    if (!visivel) {
      return;
    }
    let ativo = true;
    dataSource
      .load()
      .then((lista) => ativo && setPrefeituras(lista))
      .catch(() => ativo && setErro("Não foi possível carregar as prefeituras."));
    return () => {
      ativo = false;
    };
  }, [visivel, dataSource]);

  async function escolher(prefeitura) {
    if (trocando) {
      return;
    }
    if (!obrigatoria && parseInt(prefeitura.id) === parseInt(prefeituraAtual)) {
      onFechar && onFechar();
      return;
    }
    setErro("");
    setTrocando(true);
    const resultado = await aplicarTroca({
      api: apiAxios,
      tokenAtual: getToken(),
      prefeituraId: prefeitura.id,
      gravarSessao,
    });
    if (resultado.ok) {
      window.location.reload();
      return;
    }
    setTrocando(false);
    setErro(resultado.mensagem);
  }

  function aoFechar(e) {
    if (obrigatoria) {
      e.cancel = true;
      return;
    }
    setErro("");
    onFechar && onFechar();
  }

  return (
    <Popup
      visible={visivel}
      onHiding={aoFechar}
      onShown={() => campoBusca.current && campoBusca.current.focus()}
      wrapperAttr={{ class: "seletor-prefeitura-popup" }}
      title="Selecione a prefeitura"
      showCloseButton={!obrigatoria}
      closeOnOutsideClick={!obrigatoria}
      dragEnabled={false}
      width={760}
      maxWidth="95vw"
      height="auto"
      maxHeight="85vh"
      contentRender={() => (
        <div className="seletor-prefeitura">
          {erro ? (
            <div className="seletor-prefeitura-erro" role="alert">
              {erro}
            </div>
          ) : null}
          <input
            ref={campoBusca}
            type="text"
            className="seletor-prefeitura-busca"
            placeholder="Buscar prefeitura"
            aria-label="Buscar prefeitura"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
          {prefeituras.length > 0 && visiveis.length === 0 ? (
            <div className="seletor-prefeitura-vazio">Nenhuma prefeitura encontrada.</div>
          ) : null}
          <div className="seletor-prefeitura-cartoes">
            {visiveis.map((p) => (
              <button
                type="button"
                key={p.id}
                disabled={trocando}
                className={
                  "seletor-prefeitura-cartao" +
                  (parseInt(p.id) === parseInt(prefeituraAtual) ? " atual" : "")
                }
                onClick={() => escolher(p)}
              >
                {p.prefeituraLogo ? (
                  <img src={p.prefeituraLogo} alt="" />
                ) : (
                  <span className="seletor-prefeitura-sem-logo" />
                )}
                <span className="seletor-prefeitura-nome">{p.prefeituraTopo}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    />
  );
}
